import { render, staticRenderFns } from "./hubWiseOFDReport.vue?vue&type=template&id=1ad59574&"
import script from "./hubWiseOFDReport.vue?vue&type=script&lang=js&"
export * from "./hubWiseOFDReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports